{
  "v1.acces.chargement": "Checking your standing…",
  "v1.acces.choisie.depuis": "Since",
  "v1.acces.choisie.extension": "Extension: {{droit}}",
  "v1.acces.choisie.motif": "Reason",
  "v1.acces.choisie.origine": "Recorded origin",
  "v1.acces.choisie.origine_absente": "No recorded origin",
  "v1.acces.choisie.portee": "Scope",
  "v1.acces.choisie.reponse": "Answer",
  "v1.acces.choisie.sans_message": "No message",
  "v1.acces.choisie.statut": "Status",
  "v1.acces.choisie.titre": "Selected request",
  "v1.acces.contexte.cible": "You wanted to open: {{ecran}} {{objet}}",
  "v1.acces.contexte.projet": "Requested project: {{projet}}",
  "v1.acces.contexte.protege": "The project content is not shown until you can read it.",
  "v1.acces.contexte.titre": "Your standing",
  "v1.acces.disponibilite.chargement": "Checking the project…",
  "v1.acces.disponibilite.existe": "This project exists in your organisation; its content stays protected.",
  "v1.acces.disponibilite.indisponible": "This project is unavailable: it does not exist, or you cannot know whether it exists.",
  "v1.acces.disponibilite.membre": "You are a member of this project.",
  "v1.acces.disponibilite.titre": "Project availability",
  "v1.acces.habilitee.chargement": "Looking up authorised people…",
  "v1.acces.habilitee.non_divulguable": "Authorised people cannot be disclosed to you.",
  "v1.acces.habilitee.profils": "Can grant it: {{profils}}.",
  "v1.acces.motif.acces_retire": "Your access to this project was removed.",
  "v1.acces.motif.admission_initiale": "You are not a member of this project yet.",
  "v1.acces.motif.droit_absent": "You lack the right “{{droit}}” in this project.",
  "v1.acces.motif.droit_tenu": "You now hold the right “{{droit}}”: you can go back to the object.",
  "v1.acces.motif.membre": "You are a member of this project; no admission reason applies.",
  "v1.acces.motif.non_divulguable": "The reason cannot be disclosed to you.",
  "v1.acces.motif.politique_bloquante": "An organisation policy blocks this action.",
  "v1.acces.motif.separation_des_taches": "Separation of duties prevents you from doing this.",
  "v1.acces.motif.signale": "(reason reported when you arrived)",
  "v1.acces.origine.projet-apercu-fiche": "the preview",
  "v1.acces.origine.projet-cible-application-lecteur": "the application target",
  "v1.acces.origine.projet-document-fiche": "the document",
  "v1.acces.origine.projet-element-fiche": "the item",
  "v1.acces.origine.projet-service-environnement": "the service",
  "v1.acces.origine.projet-version-fiche": "the release",
  "v1.acces.origine.projet-vue": "the project view",
  "v1.acces.reevaluer": "Re-check my rights",
  "v1.acces.reevaluer.echec": "The re-check failed.",
  "v1.acces.reevaluer.fait": "Rights re-checked.",
  "v1.acces.retour.lien-retour-apercu": "Back to the preview",
  "v1.acces.retour.lien-retour-cible-application": "Back to the application target",
  "v1.acces.retour.lien-retour-document": "Back to the document",
  "v1.acces.retour.lien-retour-element": "Back to the item",
  "v1.acces.retour.lien-retour-service": "Back to the service",
  "v1.acces.retour.lien-retour-version": "Back to the release",
  "v1.acces.retour.lien-retour-vue": "Back to the project view",
  "v1.acces.sans_projet": "No project is given.",
  "v1.acces.separation.requise": "Someone else must act: separation of duties cannot be bypassed.",
  "v1.acces.separation.sans_objet": "Separation of duties is not involved.",
  "v1.acces.solliciter.acces": "Request access",
  "v1.acces.solliciter.deja_en_attente": "A request is already pending for this project.",
  "v1.acces.solliciter.deja_membre": "You are already a member: request the missing right instead.",
  "v1.acces.solliciter.droit": "Request this right",
  "v1.acces.solliciter.droit_en_attente": "This right is already requested.",
  "v1.acces.solliciter.droit_inconnu": "The missing right is unknown to this screen: re-check your rights.",
  "v1.acces.solliciter.fait": "Request sent.",
  "v1.acces.solliciter.impossible": "No request possible: the project is unavailable.",
  "v1.acces.solliciter.message": "Message for the authorised person (optional)",
  "v1.acces.solliciter.titre": "Request",
  "v1.acces.suite.titre": "My follow-up in this project",
  "v1.acces.suite.tout": "All my follow-up",
  "v1.acces.suite.vide": "No request for this project.",
  "v1.acces.titre": "Understand an access refusal",
  "v1.accueil.attention.titre": "Waiting for me",
  "v1.accueil.attention.total": "{{n}} items in total",
  "v1.accueil.attention.total_one": "{{n}} item in total",
  "v1.accueil.attention.tout": "All attention items",
  "v1.accueil.attention.vide": "Nothing is waiting for you.",
  "v1.accueil.code.CONTEXTE_INCOMPLET": "This project is not one of yours.",
  "v1.accueil.code.DROIT_NON_TENU": "You do not hold the required right.",
  "v1.accueil.code.ELEMENT_INTROUVABLE": "This item is no longer in your inbox.",
  "v1.accueil.code.FAVORI_HORS_DE_MES_ESPACES": "This space is not one of yours.",
  "v1.accueil.code.INVITATION_EMAIL_UNVERIFIED": "Your address is not verified: open the link you received by email.",
  "v1.accueil.code.INVITATION_EXPIREE": "This invitation has expired.",
  "v1.accueil.code.INVITATION_INTROUVABLE": "This invitation is no longer available.",
  "v1.accueil.code.NOTIFICATION_INTROUVABLE": "This notification is no longer available.",
  "v1.accueil.code.RECHERCHE_TROP_COURTE": "Type at least 3 characters.",
  "v1.accueil.code.REPORT_DATE_PASSEE": "The snooze date must be in the future.",
  "v1.accueil.code.RESOURCE_UNAVAILABLE": "Resource unavailable.",
  "v1.accueil.code.SANS_SESSION": "Your session has ended: sign in again.",
  "v1.accueil.code.SEARCH_PERIOD_INVALID": "Choose one of the offered periods.",
  "v1.accueil.code.SEARCH_TYPE_UNKNOWN": "This object type cannot be searched.",
  "v1.accueil.detail.indisponible": "This detail is no longer available: reloading was refused or failed.",
  "v1.accueil.espaces.aucun_favori": "No favourite.",
  "v1.accueil.espaces.aucun_programme": "No programme.",
  "v1.accueil.espaces.aucun_recent": "No recent space.",
  "v1.accueil.espaces.favori": "Favourite",
  "v1.accueil.espaces.favoris": "Favourites",
  "v1.accueil.espaces.programmes": "Programmes",
  "v1.accueil.espaces.projets": "Projects",
  "v1.accueil.espaces.recents": "Recent",
  "v1.accueil.espaces.retirer": "Remove {{nom}} from favourites",
  "v1.accueil.espaces.retirer_court": "Remove",
  "v1.accueil.espaces.retirer_echec": "The favourite could not be removed.",
  "v1.accueil.espaces.sante.non_publiee": "Health not published",
  "v1.accueil.espaces.titre": "My spaces",
  "v1.accueil.espaces.variante_membre": "Member view: no directory, no administration.",
  "v1.accueil.espaces.vide": "No space is accessible to you yet.",
  "v1.accueil.etat.chargement": "Loading: {{quoi}}…",
  "v1.accueil.etat.erreur": "Could not load: {{quoi}}.",
  "v1.accueil.etat.reessayer": "Retry",
  "v1.accueil.etat.refus": "Access denied: {{quoi}}.",
  "v1.accueil.lien_mes_demandes": "My requests and invitations",
  "v1.accueil.lien_mes_demandes.compteur": "My requests and invitations ({{n}} pending)",
  "v1.accueil.lien_traitements": "Running jobs",
  "v1.accueil.lien_vue_d_ensemble": "Organisation overview",
  "v1.accueil.nature.access_request_to_decide": "Access request to decide",
  "v1.accueil.nature.ai_tool_execution": "AI tool to authorise",
  "v1.accueil.nature.approval": "Approval",
  "v1.accueil.nature.campaign_to_run": "Campaign to run",
  "v1.accueil.nature.defect_to_verify": "Defect to verify",
  "v1.accueil.nature.mission_escalation": "Mission escalation",
  "v1.accueil.nature.mission_plan": "Mission plan",
  "v1.accueil.nature.mission_task_stopped": "Stopped mission task",
  "v1.accueil.nature.recette_to_run": "Acceptance run to execute",
  "v1.accueil.nature.regression_to_accept": "Regression to accept",
  "v1.accueil.nature.waiver_expired": "Expired waiver",
  "v1.accueil.nature.waiver_to_decide": "Waiver to decide",
  "v1.accueil.obstacles.bloque": "{{titre}}: blocked by {{n}} item(s)",
  "v1.accueil.obstacles.sans_tache": "Choose a task to see its project’s cadence obstacles.",
  "v1.accueil.obstacles.stagnant": "{{titre}}: unchanged for {{n}} day(s)",
  "v1.accueil.obstacles.titre": "Cadence obstacles",
  "v1.accueil.obstacles.vide": "No obstacle in the cadence.",
  "v1.accueil.premiers_pas.lien": "See my invitations and requests",
  "v1.accueil.premiers_pas.texte": "No project is open to you yet: accept an invitation or request access to a project.",
  "v1.accueil.premiers_pas.titre": "First steps",
  "v1.accueil.raccourcis": "Home shortcuts",
  "v1.accueil.refus_avant.ACCESS_DENIED": "Blocked: you lack the right to decide.",
  "v1.accueil.refus_avant.SELF_APPROVAL_REFUSED": "You are the author: someone else must decide.",
  "v1.accueil.refus_avant.autre": "Blocked ({{code}}).",
  "v1.accueil.sans_organisation": "No organisation is linked to your session.",
  "v1.accueil.tache.choisir": "Choose: {{titre}}",
  "v1.accueil.tache.disparue": "This task is no longer in your work.",
  "v1.accueil.tache.nature": "Kind",
  "v1.accueil.tache.nature.anomalie": "Defect",
  "v1.accueil.tache.nature.campagne": "Campaign to run",
  "v1.accueil.tache.nature.element": "Work item",
  "v1.accueil.tache.ouvrir": "Open in its project",
  "v1.accueil.tache.projet": "Project",
  "v1.accueil.tache.titre": "Selected task",
  "v1.accueil.tache.titre_champ": "Title",
  "v1.accueil.tache.vide": "Choose a task to see it here.",
  "v1.accueil.tache.voir": "Choose",
  "v1.accueil.titre": "My home",
  "v1.accueil.travail.cadence": "Current cadence: {{nom}}",
  "v1.accueil.travail.cadence.active": "Current cadence",
  "v1.accueil.travail.cadence.modele_sans_iteration": "This project’s model has no iterations.",
  "v1.accueil.travail.cadence.sans_cadence_active": "No cadence is running in this project.",
  "v1.accueil.travail.revue": "{{quoi}} — requested by {{qui}}",
  "v1.accueil.travail.revues": "Requested reviews ({{n}})",
  "v1.accueil.travail.rien_dans_le_projet": "Nothing is assigned to you in this project.",
  "v1.accueil.travail.titre": "My work",
  "v1.accueil.travail.vide": "Nothing is assigned to you.",
  "v1.attention.affiches": "{{n}} shown out of {{total}}",
  "v1.attention.autres.titre": "Waiting on others",
  "v1.attention.autres.vide": "Nobody owes you an answer.",
  "v1.attention.choisi.actionnable": "Yours to act on",
  "v1.attention.choisi.bloque": "Blocked, reason above",
  "v1.attention.choisi.depuis": "Since",
  "v1.attention.choisi.disparu": "This item is no longer in your inbox.",
  "v1.attention.choisi.etat": "State",
  "v1.attention.choisi.titre": "Selected item",
  "v1.attention.choisi.vide": "Choose an item to see it here.",
  "v1.attention.delais.titre": "Decision times",
  "v1.attention.delais.valeurs": "Median {{p50}}, 95% under {{p95}} ({{n}} decisions over {{jours}} days)",
  "v1.attention.delais.vide": "No decision measured over the period.",
  "v1.attention.filtre_vide": "No item of this kind.",
  "v1.attention.hitl.ligne": "{{quoi}} — waiting for {{heures}}",
  "v1.attention.hitl.titre": "Pending human decisions",
  "v1.attention.hitl.vide": "No pending human decision.",
  "v1.attention.liste.titre": "To handle",
  "v1.attention.nature": "Kind",
  "v1.attention.nature.toutes": "All kinds",
  "v1.attention.ouvrir": "Open: {{titre}}",
  "v1.attention.partiel": "Some sources could not be read: the list is partial.",
  "v1.attention.portee": "Scope",
  "v1.attention.portee.tous": "All my projects",
  "v1.attention.reporte_jusqu_au": "Snoozed until {{date}}",
  "v1.attention.reporter": "Snooze",
  "v1.attention.reporter_echec": "Snoozing failed.",
  "v1.attention.reporter_jusqu_au": "Snooze until",
  "v1.attention.reportes": "Snoozed ({{n}})",
  "v1.attention.sans_ecran": "Screen for this object coming later.",
  "v1.attention.suite": "Show more",
  "v1.attention.titre": "Attention inbox",
  "v1.demandes.a_decider": "Requests to decide",
  "v1.demandes.a_decider.ligne": "{{qui}} requests access to {{nom}} ({{date}})",
  "v1.demandes.a_decider.vide": "No request is waiting for you.",
  "v1.demandes.annuler": "Cancel my request",
  "v1.demandes.annuler.consequence": "The authorised person will no longer see it.",
  "v1.demandes.annuler.fait": "Request cancelled.",
  "v1.demandes.annuler.plus_en_attente": "This request is no longer pending.",
  "v1.demandes.annuler.reversibilite": "You can request again.",
  "v1.demandes.annuler.titre": "Cancel your request for {{nom}}?",
  "v1.demandes.annuler.verbe": "Cancel the request",
  "v1.demandes.choisir": "Choose a request.",
  "v1.demandes.decider": "Decide in {{nom}}",
  "v1.demandes.echec": "The action failed.",
  "v1.demandes.invitation.acceptee": "You joined {{nom}}.",
  "v1.demandes.invitation.accepter": "Accept",
  "v1.demandes.invitation.accepter.nom": "Accept the invitation to {{nom}}",
  "v1.demandes.invitation.expire_le": "expires on {{date}}",
  "v1.demandes.invitation.expiree_le": "expired on {{date}}",
  "v1.demandes.invitation.ignorer": "Ignore",
  "v1.demandes.invitation.ignorer.nom": "Ignore the invitation to {{nom}}",
  "v1.demandes.invitation.ouvrir": "Open the project",
  "v1.demandes.invitation.profil": "Offered profile: {{role}}",
  "v1.demandes.invitations": "Invitations received",
  "v1.demandes.invitations.vide": "No pending invitation.",
  "v1.demandes.lien.accepter": "Accept with the link",
  "v1.demandes.lien.champ": "Invitation link or code",
  "v1.demandes.lien.fait": "Invitation accepted.",
  "v1.demandes.lien.manquant": "Paste the link or code you received.",
  "v1.demandes.nature.admission": "Admission",
  "v1.demandes.nature.extension": "Right extension",
  "v1.demandes.role.contributor": "Contributor",
  "v1.demandes.role.owner": "Owner",
  "v1.demandes.role.viewer": "Viewer",
  "v1.demandes.situation": "My standing in {{nom}}",
  "v1.demandes.situation.aucune": "Choose a request to see your standing in its project.",
  "v1.demandes.sollicitations": "My access requests",
  "v1.demandes.sollicitations.vide": "You have not requested any access.",
  "v1.demandes.statut.approved": "Accepted",
  "v1.demandes.statut.cancelled": "Cancelled",
  "v1.demandes.statut.pending": "Pending",
  "v1.demandes.statut.rejected": "Refused",
  "v1.demandes.titre": "My requests and invitations",
  "v1.notifications.choisie.cible": "Object",
  "v1.notifications.choisie.disparue": "This notification is no longer in the list.",
  "v1.notifications.choisie.etat": "Read state",
  "v1.notifications.choisie.rangement": "Filing",
  "v1.notifications.choisie.recue": "Received",
  "v1.notifications.choisie.titre": "Selected notification",
  "v1.notifications.choisie.vide": "Choose a notification to see it here.",
  "v1.notifications.echec": "The action failed.",
  "v1.notifications.enregistrer": "Save",
  "v1.notifications.liste": "My notifications",
  "v1.notifications.lue": "Read",
  "v1.notifications.marquer_lue": "Mark read",
  "v1.notifications.marquer_lue.nom": "Mark read: {{titre}}",
  "v1.notifications.non_lue": "Unread",
  "v1.notifications.non_lues": "Unread only",
  "v1.notifications.projet": "Project",
  "v1.notifications.range.enregistrer": "Notification saved.",
  "v1.notifications.range.reporter": "Notification snoozed.",
  "v1.notifications.range.terminer": "Notification done.",
  "v1.notifications.rangement": "Filing",
  "v1.notifications.rangement.a_traiter": "To handle",
  "v1.notifications.rangement.enregistrees": "Saved",
  "v1.notifications.rangement.etat.a_traiter": "To handle",
  "v1.notifications.rangement.etat.enregistree": "Saved",
  "v1.notifications.rangement.etat.reportee": "Snoozed",
  "v1.notifications.rangement.etat.terminee": "Done",
  "v1.notifications.rangement.reportees": "Snoozed",
  "v1.notifications.rangement.terminees": "Done",
  "v1.notifications.rangement.toutes": "All",
  "v1.notifications.regler": "Notification settings",
  "v1.notifications.terminer": "Done",
  "v1.notifications.titre": "Notifications",
  "v1.notifications.tout_lu.fait": "{{n}} notification(s) marked read.",
  "v1.notifications.tout_lu.projet": "Mark all read ({{nom}})",
  "v1.notifications.tout_lu.tous": "Mark all read (all my projects)",
  "v1.notifications.vide": "No notification.",
  "v1.recherche.apercu.court": "Preview",
  "v1.recherche.apercu.disparu": "This result is no longer in the list.",
  "v1.recherche.apercu.nom": "Preview: {{titre}}",
  "v1.recherche.apercu.titre": "Result preview",
  "v1.recherche.apercu.vide": "Choose a result to preview it.",
  "v1.recherche.aucun": "No result for “{{q}}”.",
  "v1.recherche.auteur": "Author",
  "v1.recherche.champ": "Search",
  "v1.recherche.extrait": "Excerpt",
  "v1.recherche.invite": "Type at least 3 characters, then run the search.",
  "v1.recherche.lancer": "Run search",
  "v1.recherche.partiel": "Some types could not be read: results are partial.",
  "v1.recherche.periode": "Period",
  "v1.recherche.periode.30j": "Last 30 days",
  "v1.recherche.periode.365j": "Last 12 months",
  "v1.recherche.periode.7j": "Last 7 days",
  "v1.recherche.periode.90j": "Last 90 days",
  "v1.recherche.periode.toute": "Any time",
  "v1.recherche.reference": "Reference",
  "v1.recherche.resultats": "Results",
  "v1.recherche.statut": "Status",
  "v1.recherche.titre": "Search",
  "v1.recherche.tous_mes_espaces": "All my spaces",
  "v1.recherche.tronque": "More results exist: refine the search.",
  "v1.recherche.type": "Type",
  "v1.recherche.type.adr": "Architecture decisions",
  "v1.recherche.type.defect": "Defects",
  "v1.recherche.type.deployment": "Deployments",
  "v1.recherche.type.document": "Documents",
  "v1.recherche.type.item": "Items",
  "v1.recherche.type.mission": "Missions",
  "v1.recherche.type.program": "Programmes",
  "v1.recherche.type.project": "Projects",
  "v1.recherche.type.release": "Releases",
  "v1.recherche.type.requirement": "Requirements",
  "v1.recherche.type.sprint": "Cadences",
  "v1.recherche.type.test_campaign": "Campaigns",
  "v1.recherche.type.test_case": "Test cases",
  "v1.recherche.type.tous": "All types"
}
